import type { EmbeddingsInputs } from "../../../services/api/instances/embeddingsApi/types";

export const INITIAL_INPUT_VALUES: EmbeddingsInputs[] = [
  {
    id: "1",
    value: "",
  },
  {
    id: "2",
    value: "",
  },
  {
    id: "3",
    value: "",
  },
];